export const icons = {
    // main
    'faGarageCar': 'garage-car' || '',
    // services
    'faTemperatureSnow': 'temperature-snow',
    'faEngine': 'engine',
    'faClipboardListCheck': 'clipboard-list-check',
    'faTire': 'tire',
    'faGears': 'gears',
    'faCarWrench': 'car-wrench',
    'faSteeringWheel': 'steering-wheel',
    'faEngineWarning': 'engine-warning',
    'faBagel': 'bagel',
    'faScrewdriverWrench': 'wrench',
    'faToolbox': 'toolbox',
    'faOilCanDrip': 'oil-can-drip',
    // badges
    'faLocationCheck': 'location-check',
    'faPiggyBank': 'piggy-bank',
    'faCalendarDay': 'calendar-day',
    'faTrophyStar': 'trophy-star',
    // list buttons
    'faMagnifyingGlass': 'magnifying-glass'
}
